import { useState, useEffect } from 'react';
import api from '../services/api';

export function useCoinMarketValueHistory(range = '1m', startDate = null) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function fetchData() {
      setLoading(true);
      setError(null);
      try {
        const params = new URLSearchParams({ range });
        if (startDate) {
          params.append('startDate', startDate);
        }
        const res = await api.get(`/api/portfolio/coin-market-value-history?${params}`);
        if (!cancelled) setData(res.data);
      } catch (err) {
        if (!cancelled) setError(err.response?.data?.error || err.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    fetchData();
    return () => { cancelled = true; };
  }, [range, startDate]);

  return { data, loading, error };
} 